import {
  CreateProducerData,
  producerListResponseSchema,
} from '@/features/producers/services/schemas.ts';
import { ApiClient } from '@/common/api/ApiClient.ts';
import { createEntityResponseSchema } from '@/common/api/schemas.ts';
import { SieveParams } from '@/common/api/sieveAdapter.ts';

export const ProducerService = {
  list: async () => {
    return await ApiClient.get('/producers', producerListResponseSchema, {
      pageSize: 2147483647,
    } satisfies SieveParams);
  },
  create: async (data: CreateProducerData) => {
    return await ApiClient.post('/producers', data, createEntityResponseSchema);
  },
};
